import React, { memo } from 'react';
import Typography from '@smart-tv/components/typography';
import useStream from '../../_hooks/use-stream';
import { StreamType } from '@smart-tv/typings/content';
import Fade from '@smart-tv/components/fade/fade';
import styles from './player-controls-scrubber.module.scss';

const DisplacedIndicator = () => {
  const { streamType, streamTitles } = useStream();

  return (
    <Fade in={streamType === StreamType.StartOver && streamTitles !== undefined}>
      <div className={styles['displaced-indicator']}>
        <Typography variant="caption" className={styles['displaced-indicator__text']}>
          Forskudt
        </Typography>
      </div>
    </Fade>
  );
};

export default memo(DisplacedIndicator);
